/*
 * File: CustomCard.tsx
 * Project: a-a
 * File Created: Wednesday, 6th November 2024 8:50:29 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 17th July 2025 7:37:38 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../theme/Color';

const CustomCard: React.FC<{
  styles: SxProps<Theme>;
  children: React.ReactNode;
  className?: string;
}> = (props) => {
  return (
    <Box sx={{ ...props.styles }} className={props.className}>
      {props.children}
    </Box>
  );
};

export default CustomCard;
